export const heroBanners = [
  {
    id: 'h1',
    movieId: 'm01',
    kicker: '年度科幻巨制',
    title: '星海归途',
    meta: '2024 · 中国 · 科幻 / 冒险',
    rating: 8.7,
    description: '一次深空任务失联后，宇航员独自穿越未知星域寻找回家的航道，用宏大的宇宙想象包裹关于孤独与重逢的细腻情感。',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20space%20scene%20with%20glowing%20blue%20nebula%20and%20astronaut%20silhouette%20deep%20navy%20blue%20and%20warm%20orange%20tones%2C%20dramatic%20film%20still%2C%20epic%20composition&width=1920&height=1080&seq=hero-01&orientation=landscape',
  },
  {
    id: 'h2',
    movieId: 't01',
    kicker: '热播武侠大剧',
    title: '雾隐江湖',
    meta: '2024 · 中国 · 武侠 / 古装',
    rating: 9.0,
    description: '江湖传言失传已久的剑谱重现，隐姓埋名的剑客被迫重出江湖，恩怨家国与儿女情长在云雾群山间徐徐展开。',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20misty%20ancient%20chinese%20mountains%20with%20a%20swordsman%20silhouette%20deep%20blue%20mist%20and%20warm%20lantern%20light%2C%20dramatic%20film%20still&width=1920&height=1080&seq=hero-02&orientation=landscape',
  },
  {
    id: 'h3',
    movieId: 'm08',
    kicker: '深海惊悚巨制',
    title: '深海回响',
    meta: '2024 · 美国 · 科幻 / 惊悚',
    rating: 8.6,
    description: '一支深海科考队在马里亚纳海沟接收到无法解释的声呐回响，随着下潜加深，遇到的东西正改变着人类的认知。',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20underwater%20deep%20sea%20scene%20with%20a%20submarine%20and%20bioluminescent%20blue%20light%20warm%20orange%20accents%2C%20dramatic%20film%20still&width=1920&height=1080&seq=hero-03&orientation=landscape',
  },
  {
    id: 'h4',
    movieId: 't10',
    kicker: '史诗奇幻剧集',
    title: '破碎的皇冠',
    meta: '2023 · 美国 · 奇幻 / 古装',
    rating: 8.9,
    description: '当王国的皇冠破碎，五大家族的继承人为了王座展开角逐，魔法、权谋与命运交织成一幅恢弘的群像画卷。',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20fantasy%20throne%20room%20with%20a%20broken%20golden%20crown%20and%20warm%20candle%20light%20deep%20blue%20shadows%2C%20dramatic%20film%20still&width=1920&height=1080&seq=hero-04&orientation=landscape',
  },
];